import { extractServingRuleError } from './extractServingRuleError';

export async function readServingRuleError(
  response: Response,
  fallback: string
): Promise<string> {
  try {
    return extractServingRuleError(await response.json(), fallback);
  } catch {
    return fallback;
  }
}
